// extracted by mini-css-extract-plugin
export default {"ImageCropper":"ImageCropper_ImageCropper__8H9sV","editPhoto":"ImageCropper_editPhoto__BuumR","container":"ImageCropper_container__h-wD7"};